import { Select, SelectValue } from '@tencent/udesign/dist';
import { useEffect, useState } from 'react';
import { ITableFilterMenu } from '../../model';
import { renderFilterLabel, renderFilterTriggerNode } from './func';

interface IProps<T> {
  readonly onChanged: (key: string, value: string | string[]) => void;
  readonly columnKey: string;
  readonly value: string | string[];
  readonly filters: ITableFilterMenu<T>;
}

export function FilterSelectComponent<T>(props: IProps<T>) {
  const [value, setValue] = useState<SelectValue>();
  const { multiple } = props.filters;

  const getValue = () => {
    if (multiple) {
      return value || [];
    }
    return value || '';
  };
  const selectValue = getValue();

  const onMultipleValue = (action: 'reset' | 'ok') => {
    const tempValue = value as string[];
    props.onChanged(props.columnKey, action === 'reset' ? '' : tempValue);
  };

  const onChangedValue = (value: SelectValue) => {
    setValue(value);
    if (!multiple) {
      props.onChanged(props.columnKey, value as string);
    }
  };

  useEffect(() => {
    setValue(props.value);
  }, [props.value, props.filters.multiple]);

  const renderLabel = () => {
    return renderFilterLabel(
      props.filters.icon,
      selectValue as string | string[]
    );
  };

  return (
    <Select
      type="button"
      value={selectValue}
      onChanged={onChangedValue}
      showSearch={true}
      mode={multiple ? 'multiple' : undefined}
      options={props.filters.options.slice()}
      {...props.filters.extension}
      renderSelectedLabel={renderLabel}
      renderSelectFoot={
        multiple ? renderFilterTriggerNode(onMultipleValue) : null
      }
    />
  );
}
